import { View, Text } from "react-native";

// Components
import Task, { TaskProps } from "./Task";

// Styles
import { Typography } from "../../styles";
import { nanoid } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { selectTasks } from "../../redux/mainSlice";

const Tasks = () => {
  const tasks = useSelector(selectTasks);

  return (
    <View style={{ marginBottom: 25 }}>
      {/* Title */}
      <Text style={Typography.sectionTitle}>Today's tasks</Text>

      {/* Tasks */}
      {tasks.slice(0, 3).map((task, index) => (
        <Task
          {...task}
          key={nanoid()}
          style={{ marginBottom: index === tasks.length - 1 ? 0 : 10 }}
        />
      ))}
    </View>
  );
};

export default Tasks;
